import {
  Box,
  Grid,
  Link,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import React from "react";
import { FaFacebookF, FaPhone } from "react-icons/fa";
import { BsPinterest, BsTwitter } from "react-icons/bs";
import { FiInstagram } from "react-icons/fi";
import { HiMail } from "react-icons/hi";
import { ImLocation } from "react-icons/im";

// Logo configuration - Easy to adjust
const LOGO_CONFIG = {
  firstLogo: {
    src: "/assets/gujco-mall-logo.png", 
    alt: "Gujco Logo",
    width: 140,
    height: 112,
  },
  secondLogo: {
    src: "/assets/international-coop.png",
    alt: "International Coop Logo",
    width: 140,
    height: 52,
  },
};

function Footer() {
  return (
    <footer
      style={{
        background: "#fff",
        color: "#fff",
        position: "relative",
      }}
    >
      <Box
        className="layoutMargin"
        sx={{ py: 10, px: { lg: 0, xs: "20px" }, pb: { lg: 15 } }}
      >
        <Grid container spacing={4}>
          {/* Left: Logo + About + Social */}
          <Grid item xs={12} sm={12} md={5} lg={5} sx={{ pr: 8, textAlign: "start" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: "20px" }}>
              {/* First Logo */}
              <img
                src={LOGO_CONFIG.firstLogo.src}
                alt={LOGO_CONFIG.firstLogo.alt}
                width={LOGO_CONFIG.firstLogo.width}
                height={LOGO_CONFIG.firstLogo.height}
                style={{ objectFit: "contain" }}
              />

              {/* Second Logo */}
              <img
                src={LOGO_CONFIG.secondLogo.src}
                alt={LOGO_CONFIG.secondLogo.alt}
                width={LOGO_CONFIG.secondLogo.width}
                height={LOGO_CONFIG.secondLogo.height}
                style={{ objectFit: "contain" }}
              />
            </Box>

            <Typography
              variant="body1"
              sx={{ color: "black", fontSize: "16px", textAlign: "justify" }}
            >
              Gujco Mall is an innovative organisation that is working towards building a sustainable tomorrow and creating green job opportunities. With a vision of progress and responsibility, Gujco Mall is committed to promoting eco-friendly practices while supporting community growth and development.
            </Typography>



            {/* Social Links */}
            {/* <Box sx={{ mt: 4, display: "flex" }}>
              <Link
                href="https://www.facebook.com/profile.php?id=100083287460955&ref=pages_you_manage"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <FaFacebookF size={20} />
              </Link>
              <Link
                href="https://twitter.com/ExtraCarbon"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <BsTwitter size={20} />
              </Link>
              <Link
                href="https://www.instagram.com/extracarbonn/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <FiInstagram size={20} />
              </Link>
              <Link
                href="https://in.pinterest.com/extracarbon1279/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <BsPinterest size={20} />
              </Link>
            </Box> */}
          </Grid>

          {/* Center: Quick Links */}
          <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mt: { lg: 0, xs: "40px" } }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, textAlign: "start", fontSize: "36px", color: "black" }}
              className="caveatFont"
            >
              Quick Links
            </Typography>
            <List sx={{ p: 0, m: 0, color: "black", fontWeight: 400 }}>
              <ListItem sx={{ p: 0, mt: 2 }}>
                <Link href="#about" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  About
                </Link>
              </ListItem>
              <ListItem sx={{ p: 0, mt: 2 }}>
                <Link href="#Products" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  Products
                </Link>
              </ListItem>
              <ListItem sx={{ p: 0, mt: 2 }}>
                <Link href="#awards" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  Awards
                </Link>
              </ListItem>
              <ListItem sx={{ p: 0, mt: 2 }}>
                <Link href="#contact" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  Contact
                </Link>
              </ListItem>
            </List>
          </Grid>

          {/* Right: Contact Us */}
          <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mt: { lg: 0, xs: "40px" } }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, textAlign: "start", fontSize: "36px", color: "black" }}
              className="caveatFont"
            >
              Contact Us
            </Typography>
            <List sx={{ p: 0, m: 0, color: "black", fontWeight: 400 }}>
              <ListItem sx={{ p: 0, mt: 2, display: "flex", alignItems: "center" }}>
                <FaPhone style={{ marginRight: "10px", color: "#006940" }} />
                <Link href="tel:+02687-248881" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  02687-248881
                </Link>
              </ListItem>
              <ListItem sx={{ p: 0, mt: 2, display: "flex", alignItems: "center" }}>
                <HiMail style={{ marginRight: "10px", color: "#006940" }} />
                <Link href="mailto:info@gujcomall.com" sx={{ color: "inherit", textDecoration: "none", fontSize: "18px" }}>
                  info@gujcomall.com
                </Link>
              </ListItem>
              <ListItem sx={{ p: 0, mt: 2, display: "flex", alignItems: "center" }}>
                <ImLocation style={{ marginRight: "10px", color: "#006940" }} />
                <Typography variant="body2" sx={{ fontSize: "18px" }}>
                  Tribhuvandas Patel Estate GujCoMall, Bandhani
                </Typography>
              </ListItem>
            </List>
            <Box sx={{ mt: 4, display: "flex" }}>
              <Link
                href="/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <FaFacebookF size={20} />
              </Link>
              <Link
                href="/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <BsTwitter size={20} />
              </Link>
              <Link
                href="/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <FiInstagram size={20} />
              </Link>
              <Link
                href="/"
                sx={{
                  p: 2,
                  color: "#fff",
                  borderRadius: "7px",
                  cursor: "pointer",
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#006940",
                  "&:hover": { color: "#fff", background: "#00694060" },
                }}
              >
                <BsPinterest size={20} />
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </footer>
  );
}

export default Footer;
